import { Component, inject, OnInit } from '@angular/core';
import { ILuggage } from '@luggagehero/shared/interfaces';
import { SharedOrderService } from '@luggagehero/shared/services/orders';
import { SharedStorageCriteriaService } from '@luggagehero/shared/services/storage-criteria';

import { BookingActionBaseComponent } from '../../../../bookings/index';

@Component({ template: '' })
export abstract class CheckInActionBaseComponent extends BookingActionBaseComponent implements OnInit {
  private criteriaService = inject(SharedStorageCriteriaService);
  private orderService = inject(SharedOrderService);

  private isWalkIn: boolean;

  public get isCheckinAllowed() {
    if (this.isLoading) {
      return false;
    }
    return true;
  }

  public async ngOnInit(): Promise<void> {
    this.isWalkIn =
      this.booking.price.addOns?.walkIn || this.booking.metadata?.lh_booking_category === 'walk_in' || false;

    return super.ngOnInit();
  }

  public async checkIn() {
    // TODO: Add error handling
    this.isLoading = true;

    if (this.criteriaService.current.luggage.normal !== this.booking.luggage.normal) {
      const minBags = this.orderService.getMinimumBags(this.isWalkIn);
      const updatedLuggage: ILuggage = {
        normal: Math.max(this.criteriaService.current.luggage.normal, minBags),
        hand: 0,
      };
      // Request new quote with the adjusted number of bags
      const updatedRequest = this.orderService.getRequestForQuote(
        this.booking.shopId,
        this.booking.price.pricingModel,
        updatedLuggage,
        this.booking.period,
        this.booking.price.addOns,
        this.booking.orderDetails[0]?.orderRequest?.optionalProducts,
        this.booking.price.discountCode,
      );
      const updatedOrder = await this.orderService.generateQuote(updatedRequest);

      // Modify the booking to use the new quote
      await this.bookingService.modifyBooking(this.booking._id, updatedOrder._id);
    }

    const res = await this.bookingService.checkInForStorageLocation(this.shop._id, this.booking._id);
    this.updateBooking(res);

    void this.hideModal();
  }
}
